import { render, staticRenderFns } from "./videoCenter.vue?vue&type=template&id=a339410a&"
import script from "./videoCenter.vue?vue&type=script&lang=js&"
export * from "./videoCenter.vue?vue&type=script&lang=js&"
import style0 from "./videoCenter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./videoCenter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports